export default __webpack_public_path__ + "static/media/facebook.dbc0b505.svg";